import { Container, Typography } from '@cleartrip/ct-design-components'

import { SRP_REVAMP_SURFACE_BG as PAGE_SURFACE_BG } from '@/constants/Srp'

import type { TupleMetaTag } from '../model/types'

export interface TagsRowProps {
  tags: TupleMetaTag[]
  /** `compact` — RT unselected (10px). Default is B3 (12px). */
  density?: 'default' | 'compact'
}

const TagsRow: React.FC<TagsRowProps> = ({ density = 'default', tags }) => {
  if (!tags.length) return null

  const isCompact = density === 'compact'

  return (
    <Container className='flex flex-wrap flex-middle w-100p' css={{ columnGap: 8, minWidth: 0, rowGap: 8 }}>
      {tags.map(tag => (
        <Container
          key={tag.id}
          className='flex flex-middle flex-center flex-no-shrink br-4 px-2 py-1'
          style={{ backgroundColor: PAGE_SURFACE_BG }}
        >
          <Typography
            className={`ws-nowrap${isCompact ? ' fs-10 fw-500' : ''}`}
            color='heading'
            componentNode='span'
            variant='B3'
          >
            {tag.label}
          </Typography>
        </Container>
      ))}
    </Container>
  )
}

export default TagsRow
